import type { ShippingClient, TypedClient } from '@platform/openapi';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { statisticsPathOf, type StatisticsTab } from '../features/statistics/statistics.ts';
import { StatisticsPage } from '../features/statistics/StatisticsPage.tsx';
import { validateStatisticsSearch, type StatisticsSearch } from './search-params.ts';

export type StatisticsRouteProps = { api: TypedClient; shipping: ShippingClient; tab: StatisticsTab };

export const StatisticsRoute = ({ api, shipping, tab }: StatisticsRouteProps) => {
  const search = validateStatisticsSearch(useSearch({ strict: false }));
  const navigate = useNavigate();
  const go = (to: StatisticsTab, next: StatisticsSearch) => {
    void navigate({ to: statisticsPathOf(to), search: next });
  };
  return (
    <StatisticsPage
      api={api}
      shipping={shipping}
      tab={tab}
      preset={search.period}
      carrier={search.carrier === '' ? null : search.carrier}
      groupBy={search.groupBy === '' ? null : search.groupBy}
      onTab={(next) => {
        go(next, search);
      }}
      onPreset={(period) => {
        go(tab, { ...search, period });
      }}
      onCarrier={(carrier) => {
        go(tab, { ...search, carrier: carrier ?? '' });
      }}
      onGroupBy={(groupBy) => {
        go(tab, { ...search, groupBy: groupBy ?? '' });
      }}
    />
  );
};
